// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media(max-width: 900px){

  .hideSmallDevice {
    display: none;
  }
}
@media(min-width: 900px){

  .hideBigDevice {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/analiza/radar-chart-worker-status/radar-chart-worker-status.component.css"],"names":[],"mappings":"AAAA;;EAEE;IACE,aAAa;EACf;AACF;AACA;;EAEE;IACE,aAAa;EACf;AACF","sourcesContent":["@media(max-width: 900px){\n\n  .hideSmallDevice {\n    display: none;\n  }\n}\n@media(min-width: 900px){\n\n  .hideBigDevice {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
